export default __webpack_public_path__ + "static/media/hacker-one.d226f424.svg";